import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Menu from '../Menu'
import Icon from '../Icons'
import { View, StyleSheet, TextInput, TouchableOpacity, ViewPropTypes } from 'react-native'
import { useTheme } from '../../theming/ThemeProvider'
import { usePlatforms } from '../../hooks/usePlatforms'
import { SendToast } from '../Toast/actions'
import { useDispatch } from 'react-redux'

const getApplyFilters = obj => {
  return obj ? Object.keys(obj).length : false
}

const SearchMovementNumber = ({ initialValue, openFilters, handleSearch, style, handleClearFilters, applyFilters }) => {
  const menuItems = [
    {
      text: 'More filters',
      fn: openFilters,
      testID: 'moreFiltersOptionButton'
    }, {
      text: 'Clear filters',
      fn: handleClearFilters,
      testID: 'clearFiltersOptionButton'
    }
  ]

  const { isDesktop } = usePlatforms()
  const { theme } = useTheme()
  const styles = useStyles(theme)
  const dispatch = useDispatch()
  const [state, setState] = useState(initialValue)

  useEffect(() => {
    setState(initialValue)
  }, [initialValue])

  const handleState = text => {
    if (isNaN(+text)) return
    setState(text)
  }

  return (
    <View style={styles.row}>
      <View style={styles.container}>
        <TextInput
          style={[styles.input, style]}
          placeholder='Order number'
          value={state}
          keyboardType='numeric'
          onChangeText={handleState}
          placeholderTextColor={theme.INPUT_COLOR}
          testID='orderNumberInput'
          accessibilityLabel='orderNumberInput'
        />
        <TouchableOpacity
          activeOpacity={0.8}
          style={styles.btnSearch} onPress={() => {
            if (!state) return dispatch(SendToast({ message: 'Please write an order number to search', type: 'error' }))
            handleSearch(state)
          }}
          testID='searchByOrderNumberButton'
          accessibilityLabel='searchByOrderNumberButton'
        >
          <Icon
            name='Search'
            width={20}
            height={20}
            fill={theme.BUNKER}
            color={theme.AZTEC}
          />
        </TouchableOpacity>
      </View>
      {
        !isDesktop && (
          <Menu
            style={[
              styles.filters
            ]}
            items={menuItems}
            testID='filtersMenu'
          >
            <>
              <Icon
                name='Filter'
                width={20}
                height={20}
                fill={getApplyFilters(applyFilters) ? theme.LOCHMARA : theme.AZTEC}
              />
              {getApplyFilters(applyFilters) ? (<View style={styles.applyFilters} />) : null}

            </>
          </Menu>
        )
      }
    </View>
  )
}

const useStyles = (theme) => StyleSheet.create({

  row: {
    flexDirection: 'row',
    width: '100%',
    marginTop: 5
  },

  container: {
    borderWidth: 1,
    flexDirection: 'row',
    alignItems: 'center',
    borderColor: theme.INPUT_COLOR,
    borderRadius: 6,
    flex: 1
  },
  input: {
    flex: 1,
    paddingHorizontal: 10,
    paddingVertical: 5,
    fontSize: 16,
    color: theme.BUNKER
  },
  filters: {
    marginLeft: 10,
    width: 40,
    height: 40,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 100,
    position: 'relative',
    backgroundColor: theme.CATSKILL_WHITE
  },
  applyFilters: {
    width: 8,
    height: 8,
    position: 'absolute',
    right: -2,
    top: 5,
    backgroundColor: theme.LOCHMARA,
    borderRadius: 100
  },
  btnSearch: {
    backgroundColor: theme.CATSKILL_WHITE,
    width: 30,
    height: 30,
    borderRadius: 15,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 10
  }
})

SearchMovementNumber.defaultProps = {
  openFilters: () => null,
  openBidAndBook: () => null,
  style: {},
  handleClearFilters: () => null,
  applyFilters: {}
}

SearchMovementNumber.propTypes = {
  initialValue: PropTypes.string.isRequired,
  openFilters: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
  style: ViewPropTypes.style,
  handleClearFilters: PropTypes.func.isRequired,
  applyFilters: PropTypes.object.isRequired
}

export default SearchMovementNumber
